module.exports = __webpack_public_path__ + "img/3,w_1126.1314e7fb.jpg";